import { Component, OnInit } from '@angular/core';
import { PrintService } from '../print.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-print-appointments',
    templateUrl: './print-appointments.component.html',
    styleUrls: ['./print-appointments.component.scss'],
    standalone: false
})
export class PrintAppointmentsComponent implements OnInit {
  now:Date;
  type='day'
  startDate;
  docUID;
  code
  roomID


  constructor(
    public print:PrintService,
    private route:ActivatedRoute,
    private translate: TranslateService,) { 
    this.now=new Date();
  }

  ngOnInit(): void {
    this.type = this.route.snapshot.params.type;
    this.startDate = this.route.snapshot.params.startDate;
    this.code = this.route.snapshot.params.code;
  
    const endDate = new Date(this.startDate);
    endDate.setHours(endDate.getHours() + 24);
    const endDateIso = endDate.toISOString();
  
    if (this.type.startsWith("multi")) {
      const roomIDsParam = this.route.snapshot.queryParams['roomIDs'];
      const docUIDsParam = this.route.snapshot.queryParams['docUIDs'];
  
      const roomIDs = roomIDsParam ? roomIDsParam.split(',') : [];
      const docUIDs = docUIDsParam ? docUIDsParam.split(',') : [];
  
      if (roomIDs.length > 0) {
        this.print.loadAppointments(this.type, this.startDate, endDateIso, roomIDsParam, this.code, true, true);
      }
  
      if (docUIDs.length > 0) {
        this.print.loadAppointments(this.type, this.startDate, endDateIso, docUIDsParam, this.code, false, true);
      }
    } else {
      if (this.type === 'roomDay') {
        this.roomID = this.route.snapshot.queryParams['roomID'];
        this.print.loadAppointments(this.type, this.startDate, endDateIso, this.roomID, this.code, true);
      } else {
        this.docUID = this.route.snapshot.params['docUID'];
        this.print.loadAppointments(this.type, this.startDate, endDateIso, this.docUID, this.code, false);
      }
    }
  }
  
  

  getFundingText(funding, appointment) {
    const hmoMapping = {
        Macabi: 'מכבי',
        Leumit: 'לאומית',
        Meuhedet: 'מאוחדת',
        Clalit: 'כללית',
        Private: 'פרטי',
        IDF: 'צה"ל'
    };

    if (funding === 'Private') {
        return hmoMapping['Private'];
    } else if (funding === 'Hmo') {
        const HMO = appointment?.HMO; 
        if (HMO && hmoMapping[HMO]) {
            return hmoMapping[HMO];
        }
    }
    return ''; 
}

getExamName(appointment) {
  let examType = appointment.examName || appointment.Type;
  return this.getTranslatedExamType(examType);
}

getTranslatedExamType(examType) {
  const translationKey = `appointments.gui.exams.${examType}`;
  const translated = this.translate.instant(translationKey);
  return translated === translationKey ? examType : translated;
}


}
